<div class="material-page">
  <profile/>
  <br/>
  <profile-language/>
  <br/>
  <authentication/>
</div>